export const answers = [
  {
    id: 1,
    label: "Yes",
    value: true,
  },
  {
    id: 2,
    label: "No",
    value: false,
  },
];

export function findAnswerById(id: number) {
  return answers.find((answer) => answer.id === id);
}
